export default "__VITE_ASSET__S0YsxYVG__"